module.exports = __webpack_public_path__ + "img/bicicleta.5ed1c178.png";